// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "677d9f0ebaa0d2e4abd6" + ".chunk.js";
};